export const buildVideoStructuredData = (video) => {
  const {
    id = '',
    description = '',
    videoImage = '',
    uploadDate = '',
    videoUrl = '',
  } = video;

  return `{
    "@context": "http://schema.org",
    "@type": "VideoObject",
    "name": "${id}",
    "description": ${JSON.stringify(description)},
    "thumbnailUrl": "${videoImage}",
    "uploadDate": "${uploadDate}",
    "embedUrl": "${videoUrl}"
  }`;
};

export const buildPublisherStructuredData = (blog) => {
  const {
    title = '',
    image = '',
    publishedDateFormat = '',
    modifiedDateFormat = '',
    creator = '',
    publisher = '',
    logoUrl = '',
    description = '',
  } = blog;

  return `{
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    "headline": "${title}",
    "image": "${image}",
    "datePublished": "${publishedDateFormat}",
    "dateModified": "${modifiedDateFormat}",
    "author": {
      "@type": "Person",
      "name": "${creator}"
    },
    "publisher": {
      "@type": "Organization",
      "name": "${publisher}",
      "logo": {
        "@type": "ImageObject",
        "url": "${logoUrl}",
        "width": 275,
        "height": 59
      }
    },
    "description": ${JSON.stringify(description)}
  }`;
};

export const buildProductStructuredData = (product) => {
  const {
    displayName = '',
    description = '',
    imageURI = '',
    productId = '',
    brand = '',
    price = '',
    currency = '',
    organization = '',
  } = product || {};

  return `{
    "@context": "http://schema.org",
    "@type": "Product",
    "name": "${displayName}",
    "description": ${JSON.stringify(description)},
    "image": "${imageURI}",
    "productID": "${productId}",
    "brand": {
      "@type": "Brand",
      "name": "${brand}"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "${currency}",
      "price": "${price || 0}",
      "seller": {
        "@type": "Organization",
        "name": "${organization}"
      }
    }
  }`;
};

export const buildFaqStructuredData = (faqs) => {
  const buildFaq = (faq) => {
    const {
      title = '',
      body = '',
    } = faq;

    return `{
      "@type": "Question",
      "name": ${JSON.stringify(title)},
      "acceptedAnswer": {
        "@type": "Answer",
        "text": ${JSON.stringify(body)}
      }
    }`;
  };

  return `
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [${faqs.map(buildFaq).join()}]
  }`;
};

export const buildProductListStructuredData = (products) => {
  const structuredData = products.map((product) => buildProductStructuredData(product)).join(',');

  return products.length > 1 ? `[${structuredData}]` : structuredData;
};
